import { Box, Tab } from '@mui/material';
import { useLocation } from 'react-router';

import { PLink } from '@/ui/PLink';

interface TopBarItemProps {
  menuItem: {
    title: string;
    href: string;
  };
  value: string;
}

const TopBarItem = ({ menuItem, ...props }: TopBarItemProps) => {
  const { search } = useLocation();

  return (
    <Box sx={{ margin: { xs: '0 12px', xl: '0 28px' } }}>
      <Tab
        label={menuItem.title}
        component={PLink}
        to={`${menuItem.href}${search}`} // Passing params by search from landing page
        disableRipple
        sx={(theme) => ({
          minWidth: 0,
          // @ts-expect-error
          ...theme.typography.p3SemiBold,
          padding: '30px 0 22px',
          '&:hover': {
            opacity: 0.7,
          },
        })}
        tabIndex={0}
        {...props}
      />
    </Box>
  );
};

export default TopBarItem;
